// const mainUrl = '//www.copycheck.com'
var domainstr = location.host
// domainstr = 'oemjason.checkcopy.com'
const mainUrl = '//'+domainstr
export const defaultData = {
  baseURL: mainUrl + "/school/api",
  schoolApiURL: mainUrl + "/school/api",
  userApiURL: mainUrl + "/user/api",
  userXcxURL: mainUrl + "/xcx/api",
  copycheckURL: "http://www2.copycheck.com"
};

var secondDomains = domainstr.split(".");
var secondDomainStr = domainstr
if(secondDomains.length > 2) {
  secondDomainStr = '.'+secondDomains.slice(1).join(".")
}
export const siteInfos = {
  domain: domainstr,
  secondDomain: secondDomainStr,
};

export const pageConsts = {
  currentPage: 1,
  pageSize: 10,
  showPageSize: 5, // 显示多少条分页按钮，其他均以 ... 显示
  totalItem: 5,
  totalPage: 0,
  pageCount: 0
};

export const userLevels = {
  USER: 0,
  VIP: 1
};

export const api_user_white_list = [
  "create_weixin_concern_qrcode",
  "get_page_uuid",
  "ajax_login_verify",
  "check_tid_before"
];

export function getUrlParamsByKey(key) {
  return (
    decodeURIComponent(
      (new RegExp("[?|&]" + key + "=" + "([^&;]+?)(&|#|;|$)").exec(
        location.href
      ) || [, ""])[1].replace(/\+/g, "%20")
    ) || null
  );
}

export function isMobile() {
  return navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
}

export const upload_status_list = {
  UPLOAD_WATI: 1,
  UPLOAD_ING: 2,
  UPLOAD_SUCC: 3,
  UPLOAD_ERR: 4
};

export function reloadPageSync(params, newUrl) {
  let char = "?";
  for (var idx in params) {
    char = newUrl.indexOf("?") != -1 ? "&" : "?";
    newUrl += `${char}${idx}=${params[idx]}`;
  }
  window.history.replaceState({}, "", newUrl);
}

/**
 * 截取中文字符
 */
export function getSubStrCN(str, len) {
  var strlen = 0;
  var s = "";
  for (var i = 0; i < str.length; i++) {
    if (str.charCodeAt(i) > 128) {
      strlen += 2;
    } else {
      strlen++;
    }
    s += str.charAt(i);
    if (strlen >= len) {
      return s + "...";
    }
  }

  return s;
}

/**
 * 换算字节单位
 * @param {[int]} filesize 文件大小
 * @param {[int]} digits 保留几位小数
 * @returns 新单位字节
 */
export function formatFileSize(filesize, digits = 2) {
  let size = Number(filesize);
  if (!size || isNaN(filesize)) return "-";

  const units = ["", "K", "M", "G", "T", "P", "E", "Z", "Y", "B"];
  let base = 1024;
  let index = Math.floor(Math.log(size) / Math.log(base));
  return Math.round(size / Math.pow(base, index), digits) + "" + units[index] + "B";
}

export const serviceInfo = [
  {
    title: "PDF转换",
    converts: [
      { id: "pdf2word", title: "PDF转Word", desc: "在线将PDF文件转为Word文件", is_hot: true, type: "33" },
      { id: "pdf2excel", title: "PDF转Excel", desc: "在线将PDF文件转为Excel文件", is_hot: false, type: "34" },
      { id: "pdf2ppt", title: "PDF转PPT", desc: "在线将PDF文件转为PPT文件", is_hot: false, type: "35" },
      { id: "pdf2image", title: "PDF转图片", desc: "在线将PDF文件转为图片", is_hot: false, type: "0" },
      { id: "pdf2html", title: "PDF转HTML", desc: "在线将PDF文件转为HTML网页格式 文件", is_hot: false, type: "0" },
    ],
  },
  {
    title: "转为PDF",
    converts: [
      { id: "word2pdf", title: "Word转PDF", desc: "在线将Word文件转为PDF文件", is_hot: true, type: "0" },
      { id: "excel2pdf", title: "Excel转PDF", desc: "在线将Excel文件转为PDF文件", is_hot: false, type: "0" },
      { id: "ppt2pdf", title: "PPT转PDF", desc: "在线将PPT文件转为PDF", is_hot: false, type: "0" },
      { id: "image2pdf", title: "图片转PDF", desc: "在线将图片转为PDF文件", is_hot: false, type: "0" },
      { id: "html2pdf", title: "HTML转PDF", desc: "在线将HTML网页格式文件转为 PDF文件", is_hot: false, type: "0" },
    ],
  },
  {
    title: "PDF处理",
    converts: [
      { id: "pdf2merge", title: "PDF合并", desc: "在线将多个PDF文件合并成一个", is_hot: true, type: "0" },
      { id: "pdf2split", title: "PDF拆分", desc: "在线将按需求拆分PDF文件或者 提取指定页面", is_hot: false, type: "0" },
      { id: "pdf2watermark", title: "PDF加水印", desc: "在线给PDF文件添加水印", is_hot: false, type: "0" },
      { id: "pdf2zip", title: "PDF压缩", desc: "在线压缩PDF文件大小", is_hot: false, type: "0" },
      { id: "pdf2extract", title: "PDF提取图片", desc: "在线提取PDF文件中指定页面的 图片", is_hot: false, type: "0" },
    ],
  },
  {
    title: "PDF编辑",
    converts: [
      { id: "pdf2del", title: "PDF删除页面", desc: "在线删除PDF文件中的指定页面", is_hot: true, type: "0" },
      { id: "pdf2insert", title: "PDF插入页面", desc: "在线将PDF插入到另一个PDF的任 意位置中", is_hot: false, type: "0" },
      { id: "pdf2rotate", title: "PDF旋转", desc: "在线旋转PDF文件中的指定页面", is_hot: false, type: "0" },
      { id: "pdf2add", title: "PDF加页码", desc: "在线给PDF文件中的页面加页码", is_hot: false, type: "0" },
    ],
  },
  {
    title: "PDF安全",
    converts: [
      { id: "pdf2write", title: "PDF手写签批", desc: "在线为PDF文件添加手写签批", is_hot: true, type: "0" },
      { id: "pdf2lock", title: "PDF加密", desc: "在线为PDF文件增加密码", is_hot: true, type: "0" },
      { id: "pdf2unlock", title: "PDF去除密码", desc: "在线去除加密型PDF文件的密码", is_hot: false, type: "0" },
      { id: "print2word", title: "扫描件转Word", desc: "在线将图片型PDF转为Word", is_hot: false, type: "0" },
      { id: "image2ocr", title: "图片文字识别", desc: "在线识别并提取图片中的文字", is_hot: false, type: "0" },
    ],
  },
  {
    title: "图片转换",
    converts: [
      { id: "pdf2long", title: "PDF转长图", desc: "在线将PDF文件转为长图", is_hot: true, type: "0" },
      { id: "word2long", title: "Word转长图", desc: "在线将Word文件转为图片", is_hot: true, type: "0" },
      { id: "ppt2long", title: "PPT转长图", desc: "在线将PPT文件转为长图", is_hot: false, type: "0" },
      { id: "cad2pdf", title: "CAD转PDF", desc: "在线将CAD文件转为PDF", is_hot: false, type: "0" },
      { id: "cad2preview", title: "CAD预览", desc: "在线预览CAD文件", is_hot: false, type: "0" },
    ],
  },
  {
    title: "OFD",
    converts: [
      { id: "ofd2pdf", title: "OFD转PDF", desc: "在线将OFD文件转为PDF", is_hot: true, type: "0" },
      { id: "pdf2ofd", title: "PDF转OFD", desc: "在线将PDF文件转为OFD", is_hot: false, type: "0" },
      { id: "office2ofd", title: "Office转OFD", desc: "在线将word、excel、ppt格式文件 转为OFD", is_hot: false, type: "0" },
      { id: "image2ofd", title: "图片转OFD", desc: "在线将将图片格式文件转为OFD", is_hot: false, type: "0" },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/assets/js/common.js